<template>
	<template v-if="!state.isLoading">
		<img
			v-if="state.isFetchingMore"
			class="loader overlay"
			src="/safejournal/app-assets/images/common/loader.gif"
		/>
		<div class="header-container">
			<template v-if="authStore.user?.userType === 'student'">
				<div class="row" style="justify-content: flex-end">
					<div class="px-1">
						<button @click="openModal()" class="btn btn-primary">
							Opret notat
						</button>
					</div>
				</div>
			</template>
			<template v-if="studentId">
				<div class="row" style="justify-content: flex-end">
					<div
						class="px-1"
						v-if="
							permissionModule.hasPermission('is_add_journal') &&
							!state.isArchive
						"
					>
						<button @click="openModal()" class="btn btn-primary">
							Opret notat
						</button>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="row" style="justify-content: space-between">
					<page-header activeLink="Journal"></page-header>
					<div
						class="px-1"
						v-if="permissionModule.hasPermission('is_add_journal')"
					>
						<button @click="openModal()" class="btn btn-primary">
							Opret notat
						</button>
					</div>
				</div>
			</template>
			<div
				v-if="authStore.user?.userType !== 'student'"
				class="row mt-1"
				style="row-gap: 1rem"
			>
				<div class="px-1">
					<a @click="state.showFilters = !state.showFilters">
						<font-awesome-icon
							icon="fa-solid fa-filter"
							class="d-flex"
							height="1.75rem"
							color="var(--clr-secondary)"
							v-tooltip="'Filtrering'"
						/>
					</a>
				</div>
				<div v-if="!state.isArchive" class="px-1">
					<a @click="readAll">
						<font-awesome-icon
							icon="fa-solid fa-square-check"
							class="d-flex"
							height="1.75rem"
							color="var(--clr-secondary)"
							v-tooltip="'Marker alle som læst'"
						/>
					</a>
				</div>
				<div class="px-1">
					<a @click="toggleProperty('isNormalView')">
						<font-awesome-icon
							icon="fa-solid fa-eye"
							class="d-flex"
							height="1.75rem"
							color="var(--clr-secondary)"
							v-tooltip="'Skift visningsform'"
						/>
					</a>
				</div>
				<div
					class="px-1"
					v-if="
						permissionModule.hasPermission(
							'is_employee_can_export_journal_as_pdf',
						)
					"
				>
					<a @click="exportMulti">
						<font-awesome-icon
							icon="fa-solid fa-download"
							class="d-flex"
							height="1.75rem"
							color="var(--clr-secondary)"
							v-tooltip="'Eksporter notater'"
						/>
					</a>
				</div>
				<div
					class="px-1"
					v-if="
						permissionModule.hasPermission(
							'is_add_update_journal_info',
						)
					"
				>
					<a v-if="!state.isArchive" @click="openInfoModal">
						<font-awesome-icon
							icon="fa-regular fa-file-pen"
							class="d-flex"
							height="1.75rem"
							color="var(--clr-secondary)"
							v-tooltip="
								data.terms.journal.single === 'journal'
									? `${data.terms.journal.single_cap}informationer`
									: `${data.terms.journalCompose.single_cap}informationer`
							"
						/>
					</a>
				</div>
			</div>
			<div class="row mt-1">
				<div
					class="col p-0 content-header-filters"
					style="row-gap: 1rem"
				>
					<div
						class="px-1"
						v-if="authStore.user?.userType !== 'student'"
					>
						<div class="group" style="width: 16.5rem">
							<input
								v-model="data.searchText"
								style="background: white"
								name="searchText"
								class="form-control"
								type="text"
							/>
							<span class="highlight"></span
							><span class="bar"></span>
							<label>Søg på indhold</label>
						</div>
					</div>
					<div class="px-1">
						<date-range-picker
							@change="getDateRange"
							isStartDateWeekBefore
						></date-range-picker>
					</div>
				</div>
			</div>
			<div v-show="state.showFilters" class="row mt-1">
				<selectFilters
					v-if="userType === 'user'"
					:filters="[
						'student',
						'category',
						'theme',
						'plan',
						'template',
					]"
					:departmentOptions="data.departmentOptions"
					:employeeOptions="data.employeeOptions"
					:studentOptions="data.studentOptions"
					:categoryOptions="data.categoryOptions"
					:themeOptions="data.themeOptions"
					:planOptions="data.planOptions"
					:templateOptions="data.templateOptions"
					:tab="state.selectedTab"
					:terms="data.terms"
					:modulePermissions="modulePermissions"
					:studentId="studentId"
					@populateStudentOptions="populateOptions"
					@populateCategoryOptions="fetchCategories"
					@populatePlanOptions="fetchPlans"
					@populateThemeOptions="fetchThemes"
					@populateTemplateOptions="fetchTemplates"
					@department:selected="
						(selected) => (data.department = selected)
					"
					@student:selected="(selected) => (student = selected)"
					@employee:selected="
						(selected) => (data.employee = selected)
					"
					@category:selected="
						(selected) => (data.category = selected)
					"
					@theme:selected="(selected) => (data.theme = selected)"
					@plan:selected="(selected) => (data.plan = selected)"
					@template:selected="
						(selected) => (data.template = selected)
					"
					:studentsLoading="studentsLoading"
					:categoriesLoading="categoriesLoading"
					:themesLoading="themesLoading"
					:plansLoading="plansLoading"
					:templatesLoading="templatesLoading"
					:students="data.students"
					:departments="data.departments"
					@departmentLoaded="onDepartmentLoaded"
					@employeeLoaded="onEmployeeLoaded"
					@filterChanged="filterUpdated"
				></selectFilters>
			</div>
		</div>
		<Tabs
			v-show="authStore.user?.userType !== 'student'"
			@changed="tabChanged"
			wrapper-class="navbar p-0 mb-1"
			nav-class="nav nav-tabs justify-content-end w-100 flex-wrap-reverse"
			nav-item-class="nav-item"
			nav-item-link-class="nav-link"
			nav-item-link-active-class="active"
			nav-item-link-inactive-class=""
		>
			<Tab
				v-for="(tab, index) in data.tabList"
				:key="tab.id ?? index"
				:name="
					tab.id === 1
						? 'Pædagogiske notater'
						: tab.id === 2
							? 'Sundhedsfaglige notater'
							: tab.id === 3
								? 'Fortrolige notater'
								: tab.name
				"
				:id="tab.id ?? 'all'"
			>
			</Tab>
		</Tabs>
		<template v-if="!state.tabLoading">
			<template v-if="state.isNormalView">
				<div ref="journalRow" class="row" style="row-gap: 1.5rem">
					<journal-card
						isNormalView
						:class="
							!note.is_read && userType !== 'student'
								? 'note-unread'
								: ''
						"
						@mouseenter="
							readJournal(note.journal_id);
							note.is_read = true;
						"
						@openLogModal="openLogModal"
						@openModal="clickEditNote"
						@addComment="openCommentModal"
						@readMore="readMore"
						v-for="note in state.selectedTab !== 'all'
							? data.notes.filter(
									(note) =>
										parseInt(note.type?.id) ===
										state.selectedTab,
								)
							: data.notes"
						:key="note.journal_id"
						:note="note"
						:terms="data.terms"
						:searchText="data.searchText"
						@close="deleteJournalNote"
						:currentUser="data.currentUser"
						:store="authStore"
					/>
				</div>
			</template>
			<template v-else>
				<div ref="journalList" class="note-list">
					<journal-card
						:class="
							!note.is_read && userType !== 'student'
								? 'note-unread'
								: ''
						"
						@mouseenter="
							readJournal(note.journal_id);
							note.is_read = true;
						"
						@openLogModal="openLogModal"
						@openModal="clickEditNote"
						@addComment="openCommentModal"
						@readMore="readMore"
						v-for="note in state.selectedTab !== 'all'
							? data.notes.filter(
									(note) =>
										parseInt(note.type?.id) ===
										state.selectedTab,
								)
							: data.notes"
						:key="note.journal_id"
						:note="note"
						:terms="data.terms"
						:searchText="data.searchText"
						@close="deleteJournalNote"
						:currentUser="data.currentUser"
						:store="authStore"
					/>
				</div>
			</template>
		</template>
		<template v-else>
			<img
				class="loader"
				src="/safejournal/app-assets/images/common/loader.gif"
			/>
		</template>
		<span
			v-if="state.totalPages > 0 && data.notes.length === 0"
			class="d-flex justify-content-center red py-5"
		>
			Der er ingen notater i den valgte periode.
		</span>
		<div class="col-12" v-if="state.totalPages">
			<paginator
				:pages="state.totalPages"
				:page="filters.page"
				@pageChanged="changePage"
			></paginator>
		</div>
		<put-modal
			:data="data"
			:state="state"
			@close="fetchNewJournalNote"
			@update-drafts="updateDrafts()"
			:store="authStore"
			v-if="state.isPutModal"
		/>
		<comment-modal
			:note="data.note"
			:terms="data.terms"
			@close="onComment"
			v-if="state.isCommentModal"
			:isCommentModal="state.isCommentModal"
		/>
		<export-modal
			:tab="state.selectedTab"
			:types="data.types"
			:terms="data.terms"
			:categoryOptions="data.categoryOptions"
			:themeOptions="data.themeOptions"
			:studentOptions="filteredStudentOptions"
			:employeeOptions="data.employeeOptions"
			:departmentOptions="data.departmentOptions"
			:studentId="filters.student"
			:employee="data.employee"
			:department="data.department"
			:category="data.category"
			:theme="data.themeOptions"
			:categories="data.categoryOptions"
			:themes="data.themes"
			:plan="filters.plan"
			:planOptions="data.planOptions"
			@close="
				state.isExportModal = false;
				$emit('close');
			"
			:filters="filters"
			v-if="state.isExportModal"
			:isExportModal="state.isExportModal"
			:students="data.students"
			:isStudentModule="state.isStudentModule"
		/>
		<log-modal
			:logs="data.logs"
			:users="data.users"
			@close="
				state.isLogModal = false;
				$emit('close');
			"
			v-if="state.isLogModal"
			:isLogModal="state.isLogModal"
		/>
		<read-more-modal
			:note="data.note"
			@close="
				state.isReadMoreModal = false;
				$emit('close');
			"
			v-if="state.isReadMoreModal"
			:is-read-modal="state.isReadMoreModal"
			:terms="data.terms"
		/>
		<journal-button
			@close="fetchNewJournalNote"
			@drafts-changed="getIfTooManyDrafts"
			ref="drafts"
			:student-id="studentId"
		></journal-button>
		<journal-info-modal
			v-if="state.isInfoModal"
			:terms="data.terms"
			:isInfoModal="state.isInfoModal"
			:studentId="studentId"
			:studentOptions="data.studentOptionsWithDeps"
			@close="state.isInfoModal = false"
		></journal-info-modal>
	</template>
	<template v-else>
		<img
			class="loader"
			src="/safejournal/app-assets/images/common/loader.gif"
		/>
	</template>
</template>
<script setup>
import DateRangePicker from "@elements/datePicker/DaterangePicker.vue";
import paginator from "@elements/list/paginator.vue";
import selectFilters from "@elements/selectFilters.vue";
import permissionModule from "@helpers/PermissionHelper";
import CategoryService from "@services/CategoryService";
import DepartmentService from "@services/DepartmentService";
import JournalService from "@services/JournalService";
import PlanService from "@services/PlanService";
import StudentMetaService from "@services/StudentMetaService";
import StudentService from "@services/StudentService";
import TemplateService from "@services/TemplateService";
import ThemeService from "@services/ThemeService";
import TypeService from "@services/TypeService";
import UserService from "@services/UserService";
import {
	addDays,
	endOfDay,
	isSameDay,
	setDefaultOptions,
	startOfDay,
	subWeeks,
} from "date-fns";
import da from "date-fns/locale/da";
import Swal from "sweetalert2";
import { computed, onBeforeMount, ref, watch, watchEffect } from "vue";
import { Tab, Tabs } from "vue3-tabs-component";
import { useAuthStore } from "../../../newSrc/stores/authStore";
import vTooltip from "../../directives/tooltip";
import { journalTerm, terms } from "../../helpers/TermHelper";
import { useDebouncedRef } from "../../helpers/debouncedRef";
import pageHeader from "../pageHeader/pageHeader.ce.vue";
import journalButton from "./journalButton.ce.vue";
import journalCard from "./journalCard.vue";
import commentModal from "./modals/commentModal.vue";
import exportModal from "./modals/exportModal.vue";
import journalInfoModal from "./modals/journalInfoModal.vue";
import logModal from "./modals/logModal.vue";
import putModal from "./modals/putModal.vue";
import readMoreModal from "./modals/readMoreModal.vue";
const authStore = useAuthStore();
const userType = computed(() => {
	const userType = JSON.parse(localStorage.getItem("authState")).user
		.userType;
	return userType;
});
setDefaultOptions({ locale: da });
const drafts = ref(null);
const props = defineProps({
	studentId: Number,
	isArchive: String,
});

const typeService = new TypeService();
const journalService = new JournalService();
const categoryService = new CategoryService();
const themeService = new ThemeService();
const planService = new PlanService();
const templateService = new TemplateService();
const departmentService = new DepartmentService();
const userService = new UserService();

const getPropertyFromLocalStorage = (propertyName, defaultValue) => {
	const storedValue = localStorage.getItem(propertyName);
	return storedValue ? JSON.parse(storedValue) : defaultValue;
};

const state = ref({
	isPutModal: false,
	isLogModal: false,
	isCommentModal: false,
	isInfoModal: false,
	isExportModal: false,
	isReadMoreModal: false,
	isNormalView: getPropertyFromLocalStorage("isNormalView", false),
	showFilters: false,
	selectedTab: 1,
	isStudentModule: props.studentId ? true : false,
	isLoading: true,
	totalPages: Number,
	tabLoading: false,
	tooManyDrafts: false,
	isArchive: props.isArchive ? true : false || false,
});
const journalRow = ref(null);
const journalList = ref(null);
const employeeSelect = ref(null);
const departmentSelect = ref(null);
const onDepartmentLoaded = (department) => {
	departmentSelect.value = department;
};
const onEmployeeLoaded = (employee) => {
	employeeSelect.value = employee;
};
const getPermissions = async () => {
	await Promise.all([
		permissionModule.fetchPermissions(),
		getIsDataregistrationModule(),
		getIsPlanModule(),
	]);
};

const modulePermissions = ref(
	{
		isDataRegistrationModule: false,
	},
	{
		isPlanModule: false,
	},
);

const getIsDataregistrationModule = async () => {
	modulePermissions.value.isDataRegistrationModule =
		await permissionModule.hasModule("data_registration_module");
};
const getIsPlanModule = async () => {
	modulePermissions.value.isPlanModule =
		await permissionModule.hasModule("measurement_module");
};

const data = ref({
	studentOptions: [
		{
			label: computed(() => `Alle ${data.value.terms.student.multi}`),
			option: "",
		},
	],
	students: [],
	studentOptionsWithDeps: [],
	employeeOptions: computed(() => employeeSelect.value?.options),
	departmentOptions: computed(() => departmentSelect.value?.options),
	categoryOptions: [
		{
			label: "Alle overskrifter",
			option: 0,
		},
	],
	themeOptions: [
		{
			label: computed(() =>
				state.value.selectedTab === "all"
					? `Alle temaer/målepunkter`
					: `Alle ${
							state.value.selectedTab === 2
								? "målepunkter"
								: "temaer"
						}`,
			),
			option: 0,
		},
	],
	planOptions: [
		{
			label: "Alle planer",
			option: 0,
		},
	],
	templateOptions: [
		{
			label: "Alle dataregistreringer",
			option: 0,
		},
	],
	notes: [],
	note: {},
	types: [],
	typesWithInactive: [],
	categories: [],
	themes: [],
	plans: [],
	templates: [],
	logs: [],
	users: [],
	studentId: props.studentId,
	tabList: [
		{
			name: "Alle notater",
		},
	],
	terms: {},
	departments: ref([]),
	// Filters and selects
	category: ref(null),
	theme: ref(null),
	student: ref(null),
	department: ref(null),
	employee: ref(null),
	plan: ref(null),
	template: ref(null),
	startDate: startOfDay(subWeeks(new Date(), 1)),
	endDate: endOfDay(new Date()),
	searchText: useDebouncedRef(""),
	currentUser: ref(null),
});

watchEffect(() => {
	if (
		Array.isArray(data.value?.employeeOptions) &&
		data.value?.employeeOptions.length > 0
	) {
		data.value.employee = data.value.employeeOptions[0];
	}
	if (
		Array.isArray(data.value?.departmentOptions) &&
		data.value?.departmentOptions.length > 0
	) {
		data.value.department = data.value.departmentOptions[0];
	}
});

const student = ref(data.value.studentOptions[0]);
data.value.category = data.value.categoryOptions[0];
data.value.theme = data.value.themeOptions[0];
data.value.plan = data.value.planOptions[0];
data.value.template = data.value.templateOptions[0];

const filters = ref({
	from: computed(
		() =>
			data.value.startDate.toISOString().split("T")[0] + "T00:00:00.000Z",
	),
	to: computed(
		() => data.value.endDate.toISOString().split("T")[0] + "T23:59:59.999Z",
	),
	searchText: computed(() => data.value.searchText || null),
	department: computed(() => data.value.department?.option || null),
	employee: computed(() => data.value.employee?.option || null),
	student: computed(() => props.studentId || student.value?.option || null),
	category: computed(() =>
		data.value.category?.option === 0 ? null : data.value.category?.option,
	),
	theme: computed(() =>
		data.value.theme?.option === 0 ? null : data.value.theme?.option,
	),
	plan: computed(() =>
		data.value.plan?.option === 0 ? null : data.value.plan?.option,
	),
	template: computed(() =>
		data.value.template?.option === 0 ? null : data.value.template?.option,
	),
	type: computed(() => parseInt(state.value.selectedTab) || null),
	medicin_treatment_id: null,
	isArchive: computed(() => state.value.isArchive),
	page: 1,
});

watch(
	() => data.value.searchText,
	async () => {
		await fetchJournalNotes(filters.value);
	},
);

const filterUpdated = async (e) => {
	await fetchJournalNotes(filters.value);
};

const tabChanged = async (e) => {
	state.value.tabLoading = true;
	const tabId = e.tab.computedId;
	state.value.selectedTab = tabId;
	if (data.value.theme.type_id !== tabId) {
		data.value.theme = data.value.themeOptions[0];
	}
	if (data.value.category.type_id !== tabId) {
		data.value.category = data.value.categoryOptions[0];
	}
	filters.value.page = 1;
	await fetchJournalNotes(filters.value);
	state.value.tabLoading = false;
};

const getDateRange = async (date) => {
	if (
		data.value.startDate.getTime() != startOfDay(date.value[0]).getTime() ||
		data.value.endDate.getTime() != endOfDay(date.value[1]).getTime()
	) {
		if (
			!isSameDay(date.value[0], data.value.startDate) ||
			!isSameDay(date.value[1], data.value.endDate)
		) {
			data.value.startDate = startOfDay(date.value[0]);
			data.value.endDate = endOfDay(date.value[1]);
			await fetchJournalNotes(filters.value);
		}
	}
};

const openModal = async (id, isEdit) => {
	if (state.value.tooManyDrafts && !id) {
		tooManyDraftsPopup();
		return;
	}
	data.value.note = {};
	if (id && Number(id)) {
		data.value.note = await journalService.get(id).then((response) => {
			if (isEdit === "edit") {
				response.data.status = "block";
			}
			return response.data;
		});
	}
	Promise.all([
		populateOptions(),
		fetchCategories(),
		fetchThemes(),
		getDepartments(),
		fetchUsers(),
		fetchTemplates(),
		fetchPlans(),
	]).then(() => (state.value.isPutModal = true));
};

const openCommentModal = (id) => {
	data.value.note = {};
	if (id && Number(id)) {
		data.value.note = data.value.notes.find(
			(note) => note.journal_id === id,
		);
	}
	state.value.isCommentModal = true;
};

const onComment = async (id) => {
	await unreadJournal(id);
	state.value.isCommentModal = false;
	emit("close");
};

const openLogModal = async (id) => {
	await fetchUsers();
	if (id && Number(id)) {
		data.value.logs = await journalService.getLogs(id).then((response) => {
			let logs = [];
			response.data.forEach((log) => {
				let logActionFirstName = data.value.users.find(
					(user) => user.user_id == log.user_id,
				)?.fname;
				let logActionLastName = data.value.users.find(
					(user) => user.user_id == log.user_id,
				)?.lname;
				log.userName = `${
					logActionFirstName ? logActionFirstName : ""
				} ${logActionLastName ? logActionLastName : ""}`;
				logs.push(log);
			});
			return logs;
		});
	}
	state.value.isLogModal = true;
};

const openInfoModal = async () => {
	await populateOptions();
	state.value.isInfoModal = true;
};

async function getIfTooManyDrafts(length) {
	if (length >= 4) {
		state.value.tooManyDrafts = true;
	} else if (length < 4) {
		state.value.tooManyDrafts = false;
	} else if (length === undefined) {
		await journalService.getAllDrafts().then((response) => {
			if (response.data.length >= 4) state.value.tooManyDrafts = true;
			else state.value.tooManyDrafts = false;
		});
	}
}

const tooManyDraftsPopup = () => {
	new Swal({
		text: "Der kan kun være fire kladder aktive ad gangen",
		icon: "error",
		reverseButtons: true,
		confirmButtonText: "Ok",
		customClass: {
			confirmButton: "btn-bluedesign",
		},
	});
};

const readMore = (id) => {
	data.value.note = {};
	if (id && Number(id)) {
		data.value.note = data.value.notes.find(
			(note) => note.journal_id === id,
		);
	}
	state.value.isReadMoreModal = true;
};

const fetchAll = async () => {
	await Promise.all([
		getPermissions().then(() => fetchTypes()),
		fetchTerms(),
		getIfTooManyDrafts(),
		fetchCurrentUser(),
	]).then(() => (state.value.isLoading = false));
};

const fetchCurrentUser = async () => {
	if (authStore.user?.userType === "student") {
		data.value.currentUser = authStore.state.user.id;
	} else {
		data.value.currentUser = await userService.get(current_user_id);
	}
};

const fetchTypes = async () => {
	await typeService.getAll().then((response) => {
		data.value.types = response.data;

		data.value.types = data.value.types.filter(
			(type) =>
				type.id !== 3 ||
				permissionModule.hasPermission("is_confidential_journal") ||
				permissionModule.hasPermission("is_confidential_other_journal"),
		);

		data.value.types.forEach((type) => {
			if (type.active === 1) data.value.tabList.push(type);
		});
	});
};

const categoriesLoading = ref(false);
const fetchCategories = async () => {
	if (data.value.categories.length === 0) {
		categoriesLoading.value = true;
		data.value.categories = await categoryService
			.getAll(parseInt(props.studentId))
			.then((response) => response.data);
		const sortedCategories = data.value.categories.sort((a, b) => {
			if (a.status === "Block" && b.status !== "Block") return 1;
			if (a.status !== "Block" && b.status === "Block") return -1;
			if (a.cat_name < b.cat_name) return -1;
			if (a.cat_name > b.cat_name) return 1;
			return 0;
		});
		sortedCategories.forEach((entry) => {
			const option = {
				label: entry.cat_name,
				option: entry.id,
				type_id: entry.journal_type_id,
				status: entry.status,
				deleted: entry.deleted_at ? true : false,
				student_ids: entry.student_ids || [],
				dep_ids: entry.dep_ids
					? entry.dep_ids.split(",").map(Number)
					: [],
			};
			data.value.categoryOptions.push(option);
		});
		categoriesLoading.value = false;
	}
};

const themesLoading = ref(false);
const fetchThemes = async () => {
	if (data.value.themes.length === 0) {
		themesLoading.value = true;
		data.value.themes = await themeService
			.getAll()
			.then((response) => response.data);
		const sortedThemes = data.value.themes.sort((a, b) => {
			if (a.status === "Block" && b.status !== "Block") return 1;
			if (a.status !== "Block" && b.status === "Block") return -1;
			if (a.name < b.name) return -1;
			if (a.name > b.name) return 1;
			return 0;
		});
		sortedThemes.forEach((entry) => {
			const option = {
				label: entry.name,
				option: entry.id,
				type_id: entry.journal_type_id,
				status: entry.status,
				deleted: entry.deleted_at ? true : false,
			};
			data.value.themeOptions.push(option);
		});
		themesLoading.value = false;
	}
};

const plansLoading = ref(false);
const fetchPlans = async () => {
	if (data.value.plans.length === 0) {
		plansLoading.value = true;
		data.value.plans = props.studentId
			? await planService
					.getByStudentId(props.studentId)
					.then((response) => response.data)
			: await planService.getAll().then((response) => response.data);
		const sortedPlans = data.value.plans.sort((a, b) => {
			if (a.status === 0 && b.status !== 0) return 1;
			if (a.status !== 0 && b.status === 0) return -1;
			if (a.plans_title < b.plans_title) return -1;
			if (a.plans_title > b.plans_title) return 1;
			return 0;
		});
		sortedPlans.forEach((entry) => {
			const option = {
				label: entry.plans_title,
				option: entry.id,
				status: entry.status === 0 ? "Block" : "Active",
				student_id: parseInt(entry.student_id),
				journalNoteTypes: entry.journal_type_ids,
			};
			data.value.planOptions.push(option);
		});
		plansLoading.value = false;
	}
};

const templatesLoading = ref(false);
const fetchTemplates = async () => {
	await getDepartments();
	if (data.value.templates.length === 0) {
		templatesLoading.value = true;
		data.value.templates = await templateService
			.getTemplates({ status: "published", hide: "0", journal: "1" })
			.then((response) => response.data);
		const sortedTemplates = data.value.templates.sort((a, b) => {
			if (a.title < b.title) return -1;
			if (a.title > b.title) return 1;
			return 0;
		});
		if (data.value.departments.length > 0) {
			sortedTemplates.forEach(async (entry) => {
				const dep = data.value.departments.find(
					(dep) => dep.dep_id === entry.department_id,
				);
				const option = {
					label: entry.title,
					option: entry.id,
					category: dep?.dep_name,
					category_id: dep?.dep_id,
					tempStartDate: entry.updated_at,
				};
				data.value.templateOptions.push(option);
			});
		} else {
			sortedTemplates.forEach(async (entry) => {
				if (entry?.department_id === 0) {
					const option = {
						label: entry.title,
						option: entry.id,
						tempStartDate: entry.updated_at,
					};
					data.value.templateOptions.push(option);
				}
			});
		}
		templatesLoading.value = false;
	}
};

const fetchJournalNotes = async () => {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());
	if (params?.medicin_treatment_id) {
		filters.value.medicin_treatment_id = params.medicin_treatment_id;
	}

	try {
		let notes = {};
		if (authStore.user?.userType === "student") {
			notes = await journalService
				.getStudentNotes(filters.value)
				.then((response) => response.data);
		} else {
			notes = await journalService
				.getAll(filters.value)
				.then((response) => response.data);
		}
		const filteredNotes = Object.entries(notes)
			.filter(([key]) => key !== "totalPages")
			.map(([key, value]) => ({ ...value, key }));

		data.value.notes = filteredNotes;
		state.value.totalPages = notes.totalPages;
	} catch (error) {
		console.log(error);
		console.log(error.response?.data?.errors);
		console.log(error.response?.data?.message);
	}
};

const updateDrafts = () => {
	if (drafts.value) drafts.value.fetchDrafts();
};

const fetchNewJournalNote = async (id) => {
	if (id) {
		state.value.isLoading = true;
		const newNote = await journalService
			.get(id)
			.then((response) => response.data);
		const findIndex = data.value.notes.findIndex(
			(note) => note.journal_id == id,
		);
		if (findIndex === -1) {
			data.value.notes.unshift(newNote);
		} else {
			data.value.notes[findIndex] = newNote;
		}
	}
	state.value.isPutModal = false;
	emit("close");

	state.value.isLoading = false;
};

const fetchUpdatedJournalNote = async (id) => {
	try {
		const updated = await journalService
			.get(id)
			.then((response) => response.data);
		const find = data.value.notes.find((note) => note.journal_id == id);
		if (find) {
			Object.assign(find, updated);
		}
	} catch (error) {
		console.log(error.response?.data?.errors);
		console.log(error.response?.data?.message);
	}
};

const clickEditNote = (id) => {
	openModal(id, "edit");
	const findIndex = data.value.notes.findIndex(
		(note) => note.journal_id == id,
	);
	data.value.notes.splice(findIndex, 1);
};

const deleteJournalNote = async (id) => {
	try {
		const findIndex = data.value.notes.findIndex(
			(note) => note.journal_id == id,
		);
		data.value.notes.splice(findIndex, 1);
	} catch (error) {
		console.log(error.response?.data?.errors);
		console.log(error.response?.data?.message);
	}
};

const fetchUsers = async () => {
	if (data.value.users.length === 0) {
		data.value.users = await userService
			.getAll()
			.then((response) => response);
	}
};

const exportMulti = async () => {
	fetchCategories();
	fetchPlans();
	fetchThemes();
	populateOptions();
	state.value.isExportModal = true;
};

//// Dynamic grid
const observeWidth = () => {
	const body = document.querySelector("body");
	const handleResize = () => {
		const bodyWidth = body.clientWidth;
		if (journalRow.value) {
			if (bodyWidth <= 767) {
				journalRow.value.style.gridTemplateColumns = "1fr";
			} else {
				journalRow.value.style.gridTemplateColumns =
					"repeat(2, minmax(calc(50% - 11px), 1fr))";
			}
		}
	};

	const resizeObserver = new ResizeObserver(handleResize);
	resizeObserver.observe(body);
};

const readJournal = async (read) => {
	if (userType.value === "student") return;
	if (!data.value.notes.find((note) => note.journal_id === read).is_read) {
		try {
			await journalService.read(read).then((response) => response.data);
		} catch (error) {
			console.log(error.response?.data?.errors);
			console.log(error.response?.data?.message);
		}

		fetchUpdatedJournalNote(read);
	}
};

const unreadJournal = async (read) => {
	try {
		await journalService.unread(read).then((response) => response.data);
	} catch (error) {
		console.log(error.response?.data?.errors);
		console.log(error.response?.data?.message);
	}
	fetchUpdatedJournalNote(read);
};

const readAll = async () => {
	try {
		await journalService.readAll().then((response) => response.data);
		await fetchJournalNotes();
	} catch (error) {
		console.log(error.response?.data?.errors);
		console.log(error.response?.data?.message);
	}
};

watch(journalRow, () => {
	observeWidth();
});

const fetchTerms = async () => {
	const [termsResult, journalComposeResult] = await Promise.all([
		terms(),
		journalTerm(true),
	]);

	data.value.terms = termsResult;
	data.value.terms.journalCompose = journalComposeResult;
};

onBeforeMount(() => {
	fetchAll();
});
const studentsLoading = ref(false);
const filteredStudentOptions = ref([]);
const populateOptions = async () => {
	let newFilteredStudentOptions = [
		{
			label: computed(() => `Alle ${data.value.terms.student.multi}`),
			option: "",
		},
	];
	let withAllDepartments = [];
	await getDepartments();
	if (data.value.studentOptions.length === 1) {
		studentsLoading.value = true;
		const service = new StudentService();
		data.value.students =
			authStore.user?.userType === "student"
				? [await service.get(authStore.user?.id)]
				: await service.getAll();
		if (props.studentId) {
			data.value.students = data.value.students.filter(
				(student) => student.student_id === props.studentId,
			);
		}
		data.value.students.forEach(async (student) => {
			const departmentIDs =
				student.department_ids !== "all"
					? student.department_ids.split(",")
					: [];
			if (
				student.user_status !== "active" &&
				student.student_id !== props.studentId
			) {
				return;
			}
			if (data.value.departments?.length > 0) {
				if (departmentIDs.length === 0) {
					const option = {
						label: `${student?.fname} ${student?.lname}`,
						option: student.student_id,
					};
					newFilteredStudentOptions.push(option);
				} else {
					departmentIDs.forEach(async (id) => {
						const department = data.value.departments.find(
							(department) => department.dep_id === parseInt(id),
						);
						const option = {
							label: `${student?.fname} ${student?.lname}`,
							option: student.student_id,
							category: department?.dep_name,
							category_id: department?.dep_id,
						};
						if (
							!newFilteredStudentOptions.some(
								(opt) => opt.option == option.option,
							)
						) {
							newFilteredStudentOptions.push(option);
						} else {
							withAllDepartments.push(option);
						}
					});
				}
			} else {
				const option = {
					label: `${student?.fname} ${student?.lname}`,
					option: student.student_id,
				};
				newFilteredStudentOptions.push(option);
			}
		});
		data.value.studentOptions = newFilteredStudentOptions;
		data.value.studentOptionsWithDeps =
			newFilteredStudentOptions.concat(withAllDepartments);
		filteredStudentOptions.value = newFilteredStudentOptions;
		studentsLoading.value = false;
	}
};

const getDepartments = async () => {
	if (data.value.departments.length === 0) {
		data.value.departments = await departmentService.getAll();
	}
};

const toggleProperty = (propertyName) => {
	state.value[propertyName] = !state.value[propertyName];
	saveProperty(propertyName);
};

const changePage = (id) => {
	filters.value.page = id;
	fetchJournalNotes();
};
// Function to save a property to localStorage
const saveProperty = (propertyName) => {
	localStorage.setItem(
		propertyName,
		JSON.stringify(state.value[propertyName]),
	);
};

watch(
	() => state.value.isNormalView,
	() => saveProperty("isNormalView"),
);

const emit = defineEmits("close");
</script>
<style src="@css/app.css">
</style>
